export default __webpack_public_path__ + "static/media/Zeppelin Systems.696900fe.png";